/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.shopify.integration.rpc.DiscountCodePickerServiceRpc
 */

export const fetchDiscountCodesForPickerRpc = {
  serviceName: 'com.hubspot.shopify.integration.rpc.DiscountCodePickerServiceRpc',
  rpcName: 'fetchDiscountCodesForPicker',
  auth: 'app',
  fingerprint: 'Ge4fu4RQM7tuANTPgMMLzGzwQEVpPc8X',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};